/* Sticky Add to Cart bar — shows after the main buy buttons scroll out of view.
   Own colour/size dropdowns drive the main product form (Dawn variant-selects).
   Button state is computed from the variant data + the form's variant-id input,
   so it can never get stuck on a stale "Sold out". Clicking the button clicks
   the main submit, reusing Dawn's AJAX cart + drawer flow. */
(function () {
  var bar = document.getElementById('CloveStickyAtc');
  if (!bar) return;
  var info = document.querySelector('product-info');
  if (!info) return;

  var variants = [];
  try {
    variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
  } catch (e) {}
  if (!variants.length) return;

  var form = info.querySelector('.product-form form') || info.querySelector('form');
  var buyArea = info.querySelector('.product-form') || form;
  var submit = info.querySelector('.product-form__submit');
  var idInput = info.querySelector('.product-variant-id') || info.querySelector('[name="id"]');
  var priceSrc = info.querySelector('[id^="price-"] .price') || info.querySelector('[id^="price-"]');
  var priceDst = bar.querySelector('[data-sticky-price]');
  var btn = bar.querySelector('[data-sticky-btn]');
  var btnText = bar.querySelector('[data-sticky-btn-text]');
  var imgEl = bar.querySelector('[data-sticky-img]');
  var selects = Array.prototype.slice.call(bar.querySelectorAll('[data-sticky-option]'));

  function currentVariant() {
    if (!idInput) return variants[0];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(idInput.value)) return variants[i];
    }
    return null;
  }

  function refresh() {
    var v = currentVariant();
    if (v) {
      selects.forEach(function (sel) {
        var oi = +sel.getAttribute('data-sticky-option');
        if (sel.value !== v.options[oi]) sel.value = v.options[oi];
      });
      if (v.featured_image && v.featured_image.src && imgEl && imgEl.getAttribute('src') !== v.featured_image.src) {
        imgEl.removeAttribute('srcset');
        imgEl.src = v.featured_image.src;
      }
    }
    if (btn && btnText) {
      if (v && v.available) {
        btn.disabled = false;
        btnText.textContent = 'Add to Cart';
        bar.classList.remove('is-sold-out');
      } else if (v) {
        btn.disabled = true;
        btnText.textContent = 'Sold Out';
        bar.classList.add('is-sold-out');
      } else {
        btn.disabled = true;
        btnText.textContent = 'Unavailable';
        bar.classList.add('is-sold-out');
      }
    }
    syncPickerVisual(v);
    if (priceSrc && priceDst) {
      var cls = 'clove-sticky-atc__price ' + priceSrc.className;
      if (priceDst.className !== cls) priceDst.className = cls;
      var html = priceSrc.innerHTML;
      if (window.innerWidth < 750) html = html.replace(/ USD/g, '');
      if (priceDst.innerHTML !== html) priceDst.innerHTML = html;
    }
  }

  /* Paint the main picker's checked state + "Size: X" label to match the
     current variant. Dawn's async section swap does the logic (price, URL,
     variant id); this only ensures the visible picker never lags behind. */
  function syncPickerVisual(v) {
    var vs = info.querySelector('variant-selects');
    if (!vs || !v) return;
    var fieldsets = vs.querySelectorAll('fieldset.product-form__input');
    v.options.forEach(function (val, oi) {
      var fs = fieldsets[oi];
      if (!fs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var should = radios[i].value === val;
        if (radios[i].checked !== should) radios[i].checked = should;
      }
      var label = fs.querySelector('[data-selected-value]');
      if (label && !label.querySelector('*') && label.textContent !== val) label.textContent = val;
    });
  }

  function setFormVariant(v) {
    /* If the Glo swatch app is present it owns the visible picker (it hides
       Dawn's variant-selects and re-asserts its own state), so drive the
       change through Glo's own inputs — it then syncs Dawn itself. */
    var glo = document.querySelector('.globo-swatch-product-detail');
    if (glo) {
      v.options.forEach(function (val, oi) {
        var group = glo.querySelector('.swatch--gl[data-option-index="' + oi + '"]');
        if (!group) return;
        var inputs = group.querySelectorAll('.select-option input');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === val && !inputs[i].checked) { inputs[i].click(); break; }
        }
      });
      return;
    }
    var vs = info.querySelector('variant-selects');
    if (!vs) return;
    var fieldsets = vs.querySelectorAll('fieldset.product-form__input');
    var dropdowns = vs.querySelectorAll('select.select__select');
    v.options.forEach(function (val, oi) {
      var fs = fieldsets[oi];
      if (fs) {
        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val && !radios[i].checked) {
            radios[i].click();
          }
        }
      } else if (dropdowns[oi] && dropdowns[oi].value !== val) {
        dropdowns[oi].value = val;
        dropdowns[oi].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function onStickyChange(changedIdx) {
    var desired = selects.map(function (s) { return s.value; });
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < desired.length; j++) if (variants[i].options[j] !== desired[j]) { ok = false; break; }
      if (ok) { match = variants[i]; break; }
    }
    if (!match) {
      var best = -1;
      variants.forEach(function (v) {
        if (v.options[changedIdx] !== desired[changedIdx]) return;
        var score = 0;
        desired.forEach(function (d, j) { if (v.options[j] === d) score++; });
        if (v.available) score += 0.5;
        if (score > best) { best = score; match = v; }
      });
    }
    if (match) setFormVariant(match);
    [60, 400, 1200, 2500].forEach(function (ms) { setTimeout(refresh, ms); });
  }

  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      onStickyChange(+sel.getAttribute('data-sticky-option'));
    });
  });

  if (form) {
    form.addEventListener('change', function () { setTimeout(refresh, 60); });
  }
  if (priceSrc) {
    new MutationObserver(function () { refresh(); }).observe(priceSrc, { childList: true, subtree: true, characterData: true });
  }
  if (submit) {
    new MutationObserver(function () { refresh(); }).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }

  if (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (submit && !submit.disabled) submit.click();
      else if (submit) { submit.disabled = false; submit.click(); }
    });
  }

  refresh();

  var shown = false;
  function onScroll() {
    if (!buyArea) return;
    var r = buyArea.getBoundingClientRect();
    var show = r.bottom < 0;
    if (show !== shown) {
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }
  document.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
